import { ChangeDetectorRef, Component, Input, signal } from '@angular/core';
import { ModalDialogueService } from '../modal-dialogue/modal-dialogue.service';
import { MediaPreviewComponent } from '../media-preview/media-preview.component';
import { PagesService } from '../../../pages/pages/pages.service';
import { getPromptFileIdsForUrls } from '../../../../global.variable';

@Component({
  selector: 'gtapp-mobile-form-input-data',
  standalone: false,
  templateUrl: './mobile-form-input-data.component.html',
  styleUrl: './mobile-form-input-data.component.scss',
})
export class MobileFormInputDataComponent {
  mobileFormData = signal<any[]>([]);

  promptFileIds: any = [];
  promptFileDataUrls: any = {};

  @Input() set mobileFormDataInput(value: any[]) {
    this.mobileFormData.set(value);
    const newPromptFileIds = getPromptFileIdsForUrls(
      value || [],
      this.promptFileIds || [],
    );

    if (newPromptFileIds && newPromptFileIds?.length) {
      this.promptFileIds = newPromptFileIds;

      this.getS3UrlsForPrompts();
    }
  }

  constructor(
    private dialogService: ModalDialogueService,
    private pageService: PagesService,
    private cdr: ChangeDetectorRef,
  ) {}

  onOpenFile(file: any) {
    this.dialogService.open(MediaPreviewComponent, {
      data: {
        mediaSrc: file?.file || file?.file_url,
        timeStamp: file.updated_at,
        mediaExtension: file?.file_extension,
      },
    });
  }
  getS3UrlsForPrompts() {
    this.pageService
      .manageS3Urls({ file_ids: this.promptFileIds }, { get_file_urls: 1 })
      .subscribe((response: any) => {
        this.promptFileDataUrls = response?.data || {};
        this.cdr.detectChanges();
      });
  }
}
